import newUnitCardEn from "./locales/en.json";

export const NEW_UNIT_CARD_NS = "newUnitCard" as const;

export const NewUnitCardI18n = {
  en: {
    [NEW_UNIT_CARD_NS]: {
      ...newUnitCardEn,
    },
  },
};
